<template>
  <div
    v-if="item"
    class="d-inline-block mx-1"
  >
    <template v-for="(payment, index) in paymentTypes">
      <template
        v-if="parseInt(item.SourceTypeId) === SourceTypeEnum.TABLE && item?.Details?.Table && item?.Details?.Table?.Transactions && (item?.Details?.Table?.Transactions?.cod || item?.Details?.Table?.Transactions?.card)"
      >
        <v-chip
          v-if="item?.Details?.Table?.Transactions && item?.Details?.Table?.Transactions?.cod && payment.code === PaymentTypeEnum.CASH"
          :key="payment.code"
          :class="iconOnly ? 'pr-0' : 'pr-1'"
          :color="payment.color1"
          :small="dense"
          :style="iconOnly ? '' : `min-width: ${chipMinWidth}px; max-width: ${chipMaxWidth}px;`"
          class="white--text elevation-0 mr-1 mb-1 pl-0 text-caption"
          label
          style="text-transform: uppercase;"
        >
          <v-avatar
            :class="iconOnly ? 'ma-0' : 'mr-1'"
            :color="payment.color2"
            :style="avatarSize"
            tile
          >
            <v-icon
              :color="getIconColor(payment.color1)"
              :size="iconSize"
              class="white--text"
            >
              {{ appCurrency.Icon }}
            </v-icon>
          </v-avatar>

          <div
            v-if="!iconOnly"
            class="text-center"
            style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
          >
            <template v-if="!hideAmount">
              {{ item.Details.Table.Transactions.cod | currency }}
            </template>
            {{ $t('Order.PaymentMethod.Cash').Title.toLocaleUpperCase($i18n.locale) | truncate(truncateTitle) }}
          </div>
        </v-chip>

        <v-chip
          v-if="item.Details.Table.Transactions && item.Details.Table.Transactions.card && payment.code === PaymentTypeEnum.CARD"
          :key="payment.code"
          :class="iconOnly ? 'pr-0' : 'pr-1'"
          :color="payment.color1"
          :small="dense"
          :style="iconOnly ? '' : `min-width: ${chipMinWidth}px; max-width: ${chipMaxWidth}px;`"
          class="white--text elevation-0 mr-1 mb-1 pl-0 text-caption"
          label
          style="text-transform: uppercase;"
        >
          <v-avatar
            :class="iconOnly ? 'ma-0' : 'mr-1'"
            :color="payment.color2"
            :style="avatarSize"
            tile
          >
            <v-icon
              :color="getIconColor(payment.color1)"
              :size="iconSize"
              class="white--text"
            >
              {{ payment.icon }}
            </v-icon>
          </v-avatar>

          <div
            v-if="!iconOnly"
            class="text-center"
            style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
          >
            <template v-if="!hideAmount">
              {{ item.Details.Table.Transactions.card | currency }}
            </template>

            {{ $t('Order.PaymentMethod.Card').Title.toLocaleUpperCase($i18n.locale) | truncate(truncateTitle) }}
          </div>
        </v-chip>
      </template>

      <template v-else>
        <template v-if="hasPaymentTransactions">
          <template v-for="(transaction, idx) in paymentTransactions">
            <v-chip
              v-if="transaction.PaymentType === payment.code"
              :key="`payment-transaction-${index}-${idx}`"
              :class="iconOnly ? 'pr-0' : 'pr-1'"
              :color="payment.color1"
              :small="dense"
              :style="iconOnly ? '' : `min-width: ${chipMinWidth}px; max-width: ${chipMaxWidth}px;`"
              class="white--text elevation-0 mr-1 mb-1 pl-0 text-caption"
              label
              style="text-transform: uppercase;"
            >
              <v-avatar
                :class="iconOnly ? 'ma-0' : 'mr-1'"
                :color="payment.color2"
                :style="avatarSize"
                tile
              >
                <img
                  v-if="!!payment.image"
                  :src="`${appConfig.LOCATION_DATA.CdnUrl}assets/payments/${payment.image}`"
                  style="height: 22px; width: auto;"
                  width="auto"
                >
                <v-icon
                  v-else
                  :color="getIconColor(payment.color1)"
                  :size="iconSize"
                  class="white--text"
                >
                  {{ payment.code === PaymentTypeEnum.CASH ? appCurrency.Icon : payment.icon }}
                </v-icon>
              </v-avatar>

              <div
                v-if="!iconOnly"
                class="text-center"
                style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
              >
                <template v-if="!hideAmount">
                  {{ transaction.Amount | currency }}
                </template>
                {{
                  payment.code === PaymentTypeEnum.CASH ? $t('Order.PaymentMethod.Cash').Title.toLocaleUpperCase($i18n.locale) : payment.code === PaymentTypeEnum.CARD ? $t('Order.PaymentMethod.Card').Title.toLocaleUpperCase($i18n.locale) : payment.name.toLocaleUpperCase($i18n.locale) | truncate(truncateTitle)
                }}
              </div>
            </v-chip>
          </template>
        </template>

        <template v-else>
          <v-chip
            v-if="item.Payment === payment.code"
            :key="payment.code"
            :class="iconOnly ? 'pr-0' : 'pr-1'"
            :color="payment.color1"
            :small="dense"
            :style="iconOnly ? '' : `min-width: ${chipMinWidth}px; max-width: ${chipMaxWidth}px;`"
            class="white--text elevation-0 mr-1 mb-1 pl-0 text-caption"
            label
            style="text-transform: uppercase;"
          >
            <v-avatar
              :class="iconOnly ? 'ma-0' : 'mr-1'"
              :color="payment.color2"
              :style="avatarSize"
              tile
            >
              <v-icon
                :color="getIconColor(payment.color1)"
                :size="iconSize"
                class="white--text"
              >
                {{ payment.code === PaymentTypeEnum.CASH ? appCurrency.Icon : payment.icon }}
              </v-icon>
            </v-avatar>

            <div
              v-if="!iconOnly"
              class="text-center "
              style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
            >
              <template v-if="!hideAmount">
                {{ (item.Price || item.OrderTotal) | currency }}
              </template>
              {{
                payment.code === PaymentTypeEnum.CASH ? $t('Order.PaymentMethod.Cash').Title.toLocaleUpperCase($i18n.locale) : payment.code === PaymentTypeEnum.CARD ? $t('Order.PaymentMethod.Card').Title.toLocaleUpperCase($i18n.locale) : payment.name.toLocaleUpperCase($i18n.locale) | truncate(truncateTitle)
              }}
            </div>
          </v-chip>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import AppData from '@/mixins/appdata'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'
import PaymentType from '@/mixins/orders/paymentType'

export default {
  name      : 'OrderPaymentsChip',
  components: {},
  directives: {},
  mixins    : [AppData, PaymentType],
  props     : {
    item: {
      type   : Object,
      default: undefined
    },

    hideAmount: {
      type   : Boolean,
      default: false
    },

    iconOnly: {
      type   : Boolean,
      default: false
    },

    truncateTitle: {
      type   : Number,
      default: 1000
    },

    maxWidth: {
      type   : [Number, String],
      default: 1000
    },

    minWidth: {
      type   : [Number, String],
      default: 150
    },

    dense: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    PaymentTypeEnum() {
      return PaymentTypeEnum
    },
    SourceTypeEnum() {
      return SourceTypeEnum
    },

    chipMinWidth() {
      return this.minWidth.toString().replaceAll('px', '')
    },

    chipMaxWidth() {
      return this.maxWidth.toString().replaceAll('px', '')
    },

    iconSize() {
      return this.dense ? 18 : 22
    },

    avatarSize() {
      return `width: ${this.dense ? 32 : 46}px !important; height: 32px !important;`
    },

    allItemTransactions() {
      return this.item?.PaymentTransactions?.length ? this.item?.PaymentTransactions || [] : this.item?.Details?.Payments?.length ? this.item?.Details?.Payments || [] : []
    },

    hasPaymentTransactions() {
      const paymentTransactions = this.allItemTransactions
      return paymentTransactions.length > 0
    },
    paymentTransactions() {
      const transactions = []
      const paymentTransactions = this.allItemTransactions
      const transactionsGroupedByPaymentType = Object.groupBy(paymentTransactions, trx => trx.PaymentType)

      Object.keys(transactionsGroupedByPaymentType).forEach(key => {
        const transactionsTotal = transactionsGroupedByPaymentType[key]?.reduce((a, b) => a + parseFloat(b.Amount) || 0, 0) || 0

        transactions.push({
          Amount     : transactionsTotal.toFixed(2),
          PaymentType: key
        })
      })

      return transactions
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getIconColor(iconColor) {
      const color = iconColor || 'white'
      // eslint-disable-next-line prefer-const
      let [colorName, colorModifier] = color.toString().trim().replace('-', '').split(' ', 2)
      colorModifier = 'lighten-5'
      return `${colorName} ${colorModifier}`
    }
  }
}
</script>

<style scoped>
:deep(.v-chip > .v-chip__content) {
  width: 100%;
}
</style>
